import { Reducer } from "redux";
import { Action, ActionType } from "../actions";
import { AuthStateData, IAuthStateData } from "../state/AuthStateData";


const updateAuthData: Reducer<IAuthStateData> = (state: IAuthStateData = new AuthStateData(), action: Action<ActionType, IAuthStateData>) => {
  switch (action.type) {
    case ActionType.AUTH_MANAGER_SET:
      return { ...state, authManager: action.data };
    case ActionType.AUTH_SIGNED_IN:
      return { ...state, isLoggedIn: true };
    case ActionType.AUTH_SIGNED_OUT:
      return new AuthStateData();
    case ActionType.AUTH_GET_CURRENT_USER_PERMISSIONS:
      return {...state, userPermissions: action.data};
    default:
      return state;
  }
}

export default updateAuthData;
